import React from "react";
import { Link } from "react-router-dom";

const ContactInfo = () => {
  return (
    <>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">Contact</h1>
                </div>
                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>Contact</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="rs-contact-area rs-contact-five section-space-top">
        <div
          className="rs-contact-bg-thumb"
          style={{
            backgroundImage: "url(/assets/images/bg/contact-bg-10.png)",
          }}
        ></div>
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 col-md-6">
              <div className="rs-contact-wrapper gsap-move down-60 start-51">
                <div className="rs-contact-thumb">
                  <img src="/assets/images/bg/contact-bg-11.png" alt="" />
                </div>
                <div className="rs-contact-shape">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="54"
                    height="54"
                    viewBox="0 0 54 54"
                    fill="none"
                  >
                    <path
                      d="M0 27C0 12.0883 12.0883 0 27 0C41.9117 0 54 12.0883 54 27V54H48V27C48 15.402 38.598 6 27 6C15.402 6 6 15.402 6 27V54H0V27Z"
                      fill="#EA5501"
                    ></path>
                    <path
                      d="M27 12C18.3015 12 11.25 19.0515 11.25 27.75V54H42.75V27.75C42.75 19.0515 35.6985 12 27 12Z"
                      fill="#EA5501"
                    ></path>
                  </svg>
                </div>
                <h3 className="rs-contact-title">Head Offices</h3>
                <span className="rs-contact-meta">
                  Mon - Sat 10.00 - 18.00{" "}
                </span>
                <div className="rs-contact-btn">
                  <Link
                    className="rs-btn has-icon w-100"
                    to="https://maps.app.goo.gl/4CyH82tFmf6L8H1TA"
                  >
                    View Location
                    <span className="icon-box">
                      <svg
                        className="icon-first"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 32 32"
                      >
                        <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                      </svg>
                      <svg
                        className="icon-second"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 32 32"
                      >
                        <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                      </svg>
                    </span>
                  </Link>
                </div>
                <div className="rs-cotact-list-wrapper">
                  <div className="rs-contact-item">
                    <div className="rs-contact-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"></path>
                      </svg>
                    </div>
                    <h6>
                      <Link to="tel:01833688844">01833688844</Link>
                    </h6>
                  </div>
                  <div className="rs-contact-item">
                    <div className="rs-contact-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M22.3338 20.6286C23.0854 19.6211 23.6012 18.4577 23.8431 17.2242C24.085 15.9907 24.0468 14.7186 23.7314 13.5019C23.416 12.2851 22.8314 11.1547 22.0207 10.1941C21.21 9.23346 20.194 8.46713 19.0476 7.95164C18.7979 6.51497 18.224 5.15411 17.3695 3.97247C16.515 2.79083 15.4025 1.8195 14.1163 1.13228C12.8302 0.445066 11.4044 0.0600458 9.94712 0.00647694C8.48989 -0.047092 7.03962 0.232199 5.7065 0.82313C4.37338 1.41406 3.1925 2.30108 2.25358 3.41679C1.31465 4.53251 0.642389 5.84756 0.287871 7.26202C-0.0666478 8.67649 -0.0940951 10.1532 0.207615 11.5798C0.509324 13.0065 1.13225 14.3456 2.02907 15.4954L0.361996 17.1505C0.19558 17.3192 0.0828473 17.5333 0.0380233 17.766C-0.00680069 17.9987 0.0182925 18.2394 0.110137 18.4578C0.200111 18.6768 0.352903 18.8643 0.549258 18.9966C0.745613 19.129 0.976743 19.2002 1.21352 19.2014H8.03772C8.71732 20.6341 9.78879 21.8451 11.1281 22.6941C12.4674 23.5431 14.0198 23.9954 15.6055 23.9987H22.8015C23.0383 23.9975 23.2694 23.9263 23.4658 23.794C23.6621 23.6616 23.8149 23.4741 23.9049 23.2551C23.9967 23.0367 24.0218 22.796 23.977 22.5633C23.9322 22.3307 23.8194 22.1165 23.653 21.9478L22.3338 20.6286ZM7.21018 15.6034C7.21183 16.005 7.2439 16.4059 7.30613 16.8027H4.10391L4.52368 16.3949C4.63609 16.2834 4.72531 16.1508 4.7862 16.0047C4.84709 15.8585 4.87844 15.7017 4.87844 15.5434C4.87844 15.3851 4.84709 15.2283 4.7862 15.0822C4.72531 14.936 4.63609 14.8034 4.52368 14.6919C3.85152 14.0271 3.31865 13.235 2.95622 12.3619C2.59378 11.4887 2.40906 10.5521 2.41285 9.60672C2.41285 7.69823 3.171 5.8679 4.52051 4.51839C5.87002 3.16888 7.70035 2.41073 9.60884 2.41073C11.098 2.40178 12.5526 2.85974 13.768 3.72024C14.9835 4.58073 15.8987 5.8005 16.3851 7.20806C16.1212 7.20806 15.8694 7.20806 15.6055 7.20806C13.3789 7.20806 11.2435 8.09256 9.66911 9.66699C8.09469 11.2414 7.21018 13.3768 7.21018 15.6034ZM19.8511 21.6L19.9111 21.66H15.6055C14.2183 21.6575 12.8748 21.1742 11.804 20.2923C10.7332 19.4104 10.0012 18.1845 9.73285 16.8235C9.46447 15.4625 9.67626 14.0505 10.3321 12.8282C10.988 11.6058 12.0474 10.6486 13.3298 10.1197C14.6123 9.59076 16.0384 9.52283 17.3653 9.92746C18.6922 10.3321 19.8378 11.1842 20.6069 12.3387C21.376 13.4932 21.721 14.8787 21.5832 16.2591C21.4454 17.6394 20.8333 18.9293 19.8511 19.909C19.6252 20.1304 19.4958 20.4322 19.4913 20.7485C19.492 20.9072 19.5241 21.0642 19.5859 21.2103C19.6477 21.3565 19.7378 21.489 19.8511 21.6V21.6Z"
                          fill="#616161"
                        ></path>
                      </svg>
                    </div>
                    <h6>
                      <Link to="mailto:infoequegroup@gmail.com">
                        infoequegroup@gmail.com
                      </Link>
                    </h6>
                  </div>
                  <div className="rs-contact-item">
                    <div className="rs-contact-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="22"
                        viewBox="0 0 18 22"
                        fill="none"
                      >
                        <path
                          d="M9 18.8995L13.9497 13.9497C16.6834 11.2161 16.6834 6.78392 13.9497 4.05025C11.2161 1.31658 6.78392 1.31658 4.05025 4.05025C1.31658 6.78392 1.31658 11.2161 4.05025 13.9497L9 18.8995ZM9 21.7279L2.63604 15.364C-0.87868 11.8492 -0.87868 6.15076 2.63604 2.63604C6.15076 -0.87868 11.8492 -0.87868 15.364 2.63604C18.8787 6.15076 18.8787 11.8492 15.364 15.364L9 21.7279ZM9 11C10.1046 11 11 10.1046 11 9C11 7.89543 10.1046 7 9 7C7.8954 7 7 7.89543 7 9C7 10.1046 7.8954 11 9 11ZM9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13Z"
                          fill="#737373"
                        ></path>
                      </svg>
                    </div>
                    <h6>
                      <Link to="#">
                        Natun Babu Para, Aminul Haq Road, Saidpur, Saidpur-5310,
                        Nilphamari.
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="rs-contact-social-wrapper">
                <div className="rs-theme-social has-bg-black">
                  <Link to="#">
                    <i className="ri-facebook-fill"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-twitter-x-line"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-linkedin-fill"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-instagram-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactInfo;
